// @ts-ignore
export const isNativeApp = !!window?.ReactNativeWebView || localStorage.getItem('isNativeApp');
